import {
    IonCol, IonContent, IonHeader, IonPage, IonRow, IonTitle, IonToolbar, useIonModal, IonSearchbar,
    IonList, IonSelect, IonItem, IonSelectOption, IonLabel, IonButton, useIonViewDidEnter, IonIcon, IonFab, IonFabButton,
    isPlatform,
    useIonViewWillLeave,
    useIonAlert
} from '@ionic/react';
//import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { GoogleMap } from '@capacitor/google-maps';
import { MapType } from '@capacitor/google-maps';
import { useCallback, useEffect, useRef, useState } from 'react';
import { searchOutline, closeOutline, filterOutline, map } from "ionicons/icons";
import { Geolocation } from '@capacitor/geolocation';
import './Map.css';

import { initialMarkers } from '../data/index';
import { filteredMarkers } from '../data/index';

import axiosCall from '../data/axios';

import { MarkerInfoWindow } from '../components/MarkerInfoWindow';
import { RSBuyFilter } from '../components/RSBuyFilter';
import { MarkerClickCallbackData } from '@capacitor/google-maps/dist/typings/definitions';

import { Preferences } from '@capacitor/preferences';

import { useLocation, useHistory } from 'react-router-dom';
import { Location } from 'history';
import { set } from 'date-fns';
import { FavouritesStore } from '../data/FavouritesStore';

import { StatusBar } from '@capacitor/status-bar';
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';

interface RecentSearch {
    property_type: string;
    search: string;
    location: string;
    min_price: number;
    max_price: number;
}

const Map: React.FC = () => {
    const location = useLocation();
    const paths = location.pathname.split("/");
    const [isMapReady, setIsMapReady] = useState(false);
    const mapRef = useRef(null);
    const newMap = useRef<GoogleMap | null>(null);
    const [selectedMarker, setSelectedMarker] = useState<any>({});
    const [markers, setMarkers] = useState<any[]>([]);
    let [mode, setMode] = useState<string>('');
    const [filterQuery, setFilterQuery] = useState({});
    const [prevFilter, setPrevFilter] = useState<any>();
    const [currentMarkerIds, setCurrentMarkerIds] = useState<any[]>([]);
    let findId = new URLSearchParams(location.search).get('find');
    const [presentAlert] = useIonAlert();

    let favourites = FavouritesStore.useState(s => s.product_ids);

    //BOTTOM SHEET MODAL
    const handleDismiss = async (map: GoogleMap, clickedMarker:any, data:any) => {
        //Update maker icon
        if (clickedMarker && data.detail.data !== 'onlyDismiss') {
            //set latest favourites
            favourites = FavouritesStore.getRawState().product_ids;
            try {
                //if(currentMarkerIds.includes(clickedMarker.markerId))
                    await map.removeMarker(clickedMarker?.markerId);
            } catch (error) {
                console.error('Error removing marker:', error);
            }

            let isFav = favourites.find(f => f === `${clickedMarker.sale_type}/${clickedMarker.id}`);
            // Add the new marker
            map.addMarker({
                coordinate: {
                    lat: clickedMarker.lat,
                    lng: clickedMarker.lng
                },
                title: clickedMarker.title,
                iconUrl: isFav ? 'assets/icon/heart.png' : 'assets/icon/greencircle.png',
                iconSize: {
                    width: 15,
                    height: 15
                }
            }).then(newMarkerId => {
                // Update currentMarkerIds
                setCurrentMarkerIds(prevIds => {
                    const updatedIds = prevIds.filter(id => id !== clickedMarker.markerId);
                    updatedIds.push(newMarkerId);
                    return updatedIds;
                }); 
            });
        }
        dismiss();
    }
    const [present, dismiss] = useIonModal(MarkerInfoWindow, {
        marker: selectedMarker,
        history: useHistory(),
        onDismiss: (data:any) => dismiss(data)
    });

    if (paths.length > 2 && mode != paths[2]) {
        setMode(paths[2]);
    }
    let saleType = 'FOR_SALE';
    if (mode == 'rent')
        saleType = 'FOR_RENT';

    const [priceCeiling, setPriceCeiling] = useState(0);

    // Set default zoom level based on the screen size
    let defaultZoom = 9; // fallback
    if (window.innerWidth < 600) {
        defaultZoom = 7; // smaller zoom for mobile
    } else if (window.innerWidth < 1200) {
        defaultZoom = 8; // medium zoom for tablets
    } else {
        defaultZoom = 9; // larger zoom for desktop
    }

    const [mapZoom, setMapZoom] = useState(defaultZoom);

    const fetchListings = async (filter: any) => {
        await axiosCall("/api/listing/search", 'get', filter)
            .then((res) => {
                let newListings: any[] = [];
                let listings = res.data.listings;
                listings.forEach((listing: any) => {
                    listing.lat = Number(listing.latitude);
                    listing.lng = Number(listing.longitude);
                    newListings.push(listing);
                    if (listing.price > priceCeiling)
                        setPriceCeiling(listing.price);
                });
                setMarkers(newListings);
            })
            .catch((error) => {
                setMarkers([]);
            });
    }

    const createMap = useCallback(async () => {
        if (!mapRef.current || newMap.current) return;
        const mapConfig = {
            center: {
                lat: markers[0]?.lat || 27.237195,
                lng: markers[0]?.lng || 89.747277
            },
            zoom: mapZoom
        };

        try {
            const theMap = await GoogleMap.create({
                id: 'map',
                element: mapRef.current,
                apiKey: `${process.env.REACT_APP_GMAP_KY}`,
                config: mapConfig
            });
            if (!theMap) {
                throw new Error('Map creation failed');
            }
            // Wait for map to fully initialize
            await new Promise(resolve => setTimeout(resolve, 2000));
            // Only set map type on non-iOS platforms
            //if (isPlatform('capacitor') && !isPlatform('ios')) {
                await theMap.setMapType(MapType.Normal);
            //}

            newMap.current = theMap;
            setIsMapReady(true);
        } catch (error) {
            console.error('Error creating map:', error);
            alert('Error creating map');
        }
    }, []);

    let centerLat: number | null = null;
    let centerLng: number | null = null;

    const addMapMarker = async (marker: any, map: GoogleMap) => {
        if(findId && marker.slug == findId) {
            centerLat = marker.lat;
            centerLng = marker.lng;
            return await map.addMarker({
                coordinate: {
                    lat: marker.lat,
                    lng: marker.lng
                },
                title: marker.label,
                iconUrl: 'assets/icon/yellowcircle.png',
                iconSize: {
                    width: 30,
                    height: 30
                },
                tintColor: { r: 24, g: 55, b: 145, a: 255 }
            });
        } else {
            let isFav = favourites.find(f => f === `${marker.sale_type}/${marker.id}`);
            return await map.addMarker({
                coordinate: {
                    lat: marker.lat,
                    lng: marker.lng
                },
                title: marker.label,
                iconUrl: isFav ? 'assets/icon/heart.png' : 'assets/icon/redmarker.png',
                iconSize: {
                    width: 15,
                    height: 15
                },
                tintColor: { r: 24, g: 55, b: 145, a: 255 }
            });
        }

    }

    const addMapMarkers = async(passedMarkers: any, map: GoogleMap) => {
        const markerPromises = passedMarkers.map((marker: any) => addMapMarker(marker, map));
        const resolvedMarkers = await Promise.all(markerPromises);
        setCurrentMarkerIds(resolvedMarkers);
    }

    function markerClick(marker: MarkerClickCallbackData, map: GoogleMap) {
        //console.log(marker.latitude);
        if(marker.title == "Your Location") {
            presentAlert({
                header: 'You are here!',
                subHeader: 'Your Location',
                message: 'This is your current location.',
                cssClass: 'drukre',
                buttons: ['Ok'],
            });
            return;
        }

        let clickedMarker = markers.find(m => (m.lat === marker.latitude && m.lng === marker.longitude));
        
        clickedMarker.markerId = marker.markerId;
        setSelectedMarker(clickedMarker);

        //MODAL CONFIGS
        const modalOptions = {
            initialBreakpoint: 0.5,
            breakpoints: [0, 0.4, 0.7, 1],
            backdropBreakpoint: 0,
            onDidDismiss: (data:any) => handleDismiss(map, clickedMarker, data),
            expandToScroll: false,
        };
        present(modalOptions);
    }

    // Define the country's boundaries (example: Bhutan)
    const countryBounds = {
        north: 28.246987,
        south: 26.702016,
        west: 88.746472,
        east: 92.125232
    };

    const setMapCamera = async (mrkrs: any) => {
        try {
            const position = await Geolocation.getCurrentPosition();
            const userLat = position.coords.latitude;
            const userLng = position.coords.longitude;

            // Check if the user's location is within the country's boundaries
            if (newMap.current) {
                if (
                    userLat >= countryBounds.south &&
                    userLat <= countryBounds.north &&
                    userLng >= countryBounds.west &&
                    userLng <= countryBounds.east
                ) {
                    newMap.current.setCamera({
                        coordinate: {
                            lat: centerLat || userLat,
                            lng: centerLng || userLng
                        },
                        zoom: centerLat ? 12 : defaultZoom,
                        animate: true,
                    });
                } else {
                    newMap.current.setCamera({
                        coordinate: {
                            lat: centerLat || mrkrs[0]?.lat || 27.237195,
                            lng: centerLng || mrkrs[0]?.lng || 89.747277
                        },
                        zoom: centerLat ? 12 : defaultZoom,
                        animate: true,
                    });
                }
            }
        } catch (error) {
            console.error('Error getting user location:', error);
        }
    };

    useEffect(() => {
        if (!newMap.current) return;
        // Clear existing markers
        newMap.current.removeMarkers(currentMarkerIds);
        newMap.current.disableClustering();
        if (newMap.current) {
            newMap.current.setOnMarkerClickListener((marker) => markerClick(marker, newMap.current!));
        }
        // Add new markers
        addMapMarkers(markers, newMap.current);
        // Set camera to the first marker's position or user's location
        setMapCamera(markers);
        newMap.current.enableClustering();
        newMap.current.setOnClusterClickListener((cl) => {
            setMapZoom(prevZoom => {
                const zoomIncrement = prevZoom + 1;
                if (newMap.current) {
                    newMap.current.setCamera({
                        zoom: zoomIncrement,
                        coordinate: {
                            lat: cl.latitude,
                            lng: cl.longitude
                        },
                        angle: 0,
                        animate: true,
                        animationDuration: 2
                    });
                }
                return zoomIncrement;
            });
        });

        //RESET ZOOM WHEN ZOOMED OUT
        newMap.current.setOnBoundsChangedListener(async () => {
            if (!newMap.current) return;
            const bounds = await newMap.current.getMapBounds();
            // Calculate the latitude and longitude span
            const latSpan = Math.abs(bounds.northeast.lat - bounds.southwest.lat);
            const lngSpan = Math.abs(bounds.northeast.lng - bounds.southwest.lng);

            // Set your own threshold for "zoomed out" (adjust as needed)
            const LAT_THRESHOLD = 5;
            const LNG_THRESHOLD = 5;

            if (latSpan > LAT_THRESHOLD || lngSpan > LNG_THRESHOLD) {
                setMapZoom(defaultZoom);
            }
        });
    }, [markers, isMapReady, newMap.current]);

    useIonViewDidEnter(() => {

        // Disable status bar for map page
        const disableEdgeToEdge = async () => {
            if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
                try {
                    await StatusBar.hide();
                    await EdgeToEdge.disable();
                    console.log('Edge-to-edge mode disabled for map page');
                } catch (error) {
                    console.error('Error disabling edge-to-edge mode:', error);
                }
            }
        };
        disableEdgeToEdge();

        createMap();
        if (`${process.env.REACT_APP_ENVIRONMENT}` == 'development') {
            setMarkers(initialMarkers);
        } else {
            setFilterQuery({});
            return;
        }
    });

    useEffect(() => {
        var q = { sale_type: saleType };
        if (filterQuery)
            q = Object.assign(q, filterQuery);
        if(process.env.REACT_APP_ENVIRONMENT == 'development') {
            setMarkers(filteredMarkers);
        } else
            fetchListings(q);
    }, [filterQuery]);

    useIonViewWillLeave(() => {
        console.log('Cleaning up map on route change');

        // Handle async operations without making the callback async
        const cleanupEdgeToEdge = async () => {
            // Re-enable edge-to-edge mode when leaving map page
            if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') {
                try {
                    await StatusBar.show();
                    await EdgeToEdge.enable();
                    console.log('Edge-to-edge mode enabled when leaving map page');
                } catch (error) {
                    console.error('Error enabling edge-to-edge mode:', error);
                }
            }
        };
        
        // Call the async function but don't await it in the callback
        cleanupEdgeToEdge();

        if (newMap.current) {
            newMap.current.destroy();
            newMap.current = null;
            setIsMapReady(false);
            setCurrentMarkerIds([]);
        }
    });

    //FILTER
    const filterDismiss = () => {
        setPresentingElement();
    }
    const [presentingElement, setPresentingElement] = useIonModal(RSBuyFilter, {
        onDismiss: filterDismiss,
        apply: applyFilter,
        prevFilter: prevFilter,
        map: null,
        priceCeiling: priceCeiling
    });

    const filterClick = async () => {
        let rsFilter = await Preferences.get({ key: 'rsFilter' });
        setPrevFilter(rsFilter.value);
        setPresentingElement();
        presentingElement();
    };

    async function applyFilter(data: any) {
        let rsFilter = await Preferences.get({ key: 'rsFilter' });
        let rsFilterValue = [];
        try {
            rsFilterValue = rsFilter.value ? JSON.parse(rsFilter.value) : [];
            if (!Array.isArray(rsFilterValue)) {
                rsFilterValue = [];
            }
        } catch (error) {
            console.error('Error parsing rsFilter value:', error);
            rsFilterValue = [];
        }
        if (rsFilterValue && !rsFilterValue.some((recent: RecentSearch ) => recent.property_type === data.property_type && recent.location === data.state)) {
            rsFilterValue.unshift({ property_type: data.property_type, search: data.q, location: data.state, min_price: data.priceMin, max_price: data.priceMax });
            if (rsFilterValue.length > 5) {
                rsFilterValue = rsFilterValue.slice(0, 5);
            }
            await Preferences.set({ key: 'rsFilter', value: JSON.stringify(rsFilterValue) });
        }
        setFilterQuery(data);
        setPresentingElement();
    }

    const viewMyLocation = async () => {
        if (newMap.current) {
            const position = await Geolocation.getCurrentPosition();
            const userLat = position.coords.latitude;
            const userLng = position.coords.longitude;

            let myLocMarkerID = await newMap.current.addMarker({
                coordinate: {
                    lat: userLat,
                    lng: userLng
                },
                title: 'Your Location',
                iconUrl: 'assets/icon/userlocation.png'
            });
            // Remove marker after 60 seconds
            setTimeout(() => {
                if (newMap.current && myLocMarkerID) {
                    newMap.current.removeMarker(myLocMarkerID);
                }
            }, 60000);
            
            // Check if the user's location is within the country's boundaries
            if (
                userLat >= countryBounds.south &&
                userLat <= countryBounds.north &&
                userLng >= countryBounds.west &&
                userLng <= countryBounds.east
            ) {
                newMap.current.setCamera({
                    coordinate: {
                        lat: userLat,
                        lng: userLng
                    },
                    animate: true,
                });
                
            } else {
                presentAlert({
                    header: 'Alert!',
                    subHeader: 'Unsupported Location',
                    message: 'Your location is outside the supported area! Please zoom out to see your self.',
                    cssClass: 'drukre',
                    buttons: ['Ok'],
                });

                newMap.current.setCamera({
                    animate: true,
                    zoom: 3
                });
            }
        } else {
            presentAlert({
                header: 'Error',
                message: 'Map is not initialized yet.',
                cssClass: 'drukre',
                buttons: ['Ok'],
            });
        }
    }

    // Add this function to your Map component
    const requestLocationPermission = async () => {
        try {
            if (Capacitor.isNativePlatform()) {
                // Your existing native platform code
                const permissionStatus = await Geolocation.checkPermissions();
                
                if (permissionStatus.location === 'granted') {
                    viewMyLocation();
                } 
                else if (permissionStatus.location === 'denied') {
                    // Show settings dialog for native platforms
                    presentAlert({
                        header: 'Location Access Required',
                        message: 'This app needs access to your location. Please enable location permissions in your device settings.',
                        buttons: [
                            { text: 'Cancel', role: 'cancel' },
                            {
                                text: 'Open Settings',
                                handler: async () => {
                                    if (Capacitor.getPlatform() === 'ios') {
                                        //await App.openUrl({ url: 'app-settings:' });
                                    } else if (Capacitor.getPlatform() === 'android') {
                                         //const info = await App.getInfo();
                                        //await App.openUrl({ url: 'package:' + info.id });
                                    }
                                }
                            }
                        ]
                    });
                } 
                else {
                    // First time request for native
                    const requestResult = await Geolocation.requestPermissions();
                    if (requestResult.location === 'granted') {
                        viewMyLocation();
                    } else {
                        presentAlert({
                            header: 'Location Access Denied',
                            message: 'Unable to show your location without permission.',
                            buttons: ['OK']
                        });
                    }
                }
            } else {
                // Web browser handling
                try {
                    // For browsers, just try to get the position
                    // This will automatically trigger the permission prompt if needed
                    await viewMyLocation();
                } catch (error) {
                    // Check if it's a permission error
                    if (typeof error === 'object' && error !== null && 'code' in error && (error as any).code === 1) { // PERMISSION_DENIED
                        presentAlert({
                            header: 'Location Access Denied',
                            message: 'Please allow location access in your browser settings. You may need to click the location icon in your address bar or refresh and try again.',
                            buttons: ['OK']
                        });
                    } else {
                        presentAlert({
                            header: 'Error',
                            message: 'Could not get your location: ' + (typeof error === 'object' && error !== null && 'message' in error ? (error as any).message : String(error)),
                            buttons: ['OK']
                        });
                    }
                }
            }
        } catch (error) {
            console.error('Error requesting location permission:', error);
            presentAlert({
                header: 'Error',
                message: 'Could not request location permissions.',
                buttons: ['OK']
            });
        }
    };

    const changeMapType = async (type: MapType) => {
        if (!newMap.current) return;
        
        const platform = Capacitor.getPlatform();
        
        if (platform === 'ios') {
            // iOS-specific implementation
            try {
                // Try with a delay for iOS
                setTimeout(() => newMap.current?.setMapType(type), 500);
            } catch (error) {
                    console.error('iOS setMapType error:', error);
            }
        } else if (platform === 'android') {
            // Android-specific implementation
            try {
                await newMap.current.setMapType(type);
                setTimeout(() => newMap.current?.setMapType(type), 1500);
            } catch (error) {
                console.error('Android setMapType error:', error);
            }
        } else {
            // Web implementation
            await newMap.current.setMapType(type);
        }
    };

    return (
        <IonPage className="mapView">
            <IonHeader>
                <IonToolbar>
                    <IonTitle>Capacitor Google Map</IonTitle>
                </IonToolbar>
                { Capacitor.isNativePlatform() ? (
                    <IonRow className="ion-center ion-justify-content-center">
                        <IonButton color="light" onClick={() => changeMapType(MapType.Satellite)}>
                            Satellite
                        </IonButton>
                        <IonButton color="light" onClick={() => changeMapType(MapType.Normal)}>
                            Normal
                        </IonButton>
                        <IonButton color="light" onClick={() => requestLocationPermission()}>
                            My location
                        </IonButton>
                    </IonRow>
                ) : (
                    <IonRow className="ion-center ion-justify-content-center">
                        <IonButton color="light" onClick={() => requestLocationPermission()}>
                            See my location
                        </IonButton>
                    </IonRow>
                )}
            </IonHeader>
            <IonContent className="mapView">
                <IonRow>
                    <IonCol size="12">
                        <capacitor-google-map ref={mapRef} id="map"></capacitor-google-map>
                    </IonCol>
                </IonRow>
            </IonContent>
            <IonFab vertical="bottom" slot="fixed">
                <IonFabButton className="filterFab" color="drukre" id="open-filter" onClick={() => filterClick()}>
                    Filter<IonIcon icon={searchOutline} />
                </IonFabButton>
            </IonFab>
        </IonPage>
    )
}

export default Map;